export default "__VITE_ASSET__c622e6cf__"